import { ReactNode, useRef } from "react";

import { LazyStateContext, PickingSession } from "./context";

export function PickingSessionProvider({ children }: { children: ReactNode }) {
    const ref = useRef<PickingSession | null>(null);

    return <LazyStateContext.Provider value={ref}>{children}</LazyStateContext.Provider>;
}
